import { useSessionContext } from 'src/contexts';

export const useGetCurrentCompanyId = () => {
  const [{ currentCompanyId }] = useSessionContext();

  return currentCompanyId;
};
